import { render, staticRenderFns } from "./VContactCoworkerItem.vue?vue&type=template&id=3881db9b&"
import script from "./VContactCoworkerItem.vue?vue&type=script&lang=js&"
export * from "./VContactCoworkerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports